var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 14,
    height: 14,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8386 1.168C23.5549 0.448 22.9541 0 22.2711 0H1.72584C1.04277 0 0.441982 0.448 0.157441 1.168C-0.124528 1.882 -0.0268246 2.698 0.411985 3.296L0.412843 3.297L8.57025 14.371V23C8.57025 23.369 8.74423 23.708 9.02277 23.882C9.14962 23.961 9.28846 24 9.4273 24C9.59357 24 9.75898 23.943 9.90297 23.832L15.0453 19.832C15.2835 19.646 15.4267 19.334 15.4267 19V14.371L23.5849 3.297C24.0237 2.698 24.1214 1.882 23.8386 1.168Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.aaaee6abae21f0922c9e43004453aa73.svg";
export { ForwardRef as ReactComponent };